import React from 'react';

import logo from "../assets/svgs/Logo_Acesco_Color.svg";
import iconWarranty from "../assets/svgs/Icon_Garantia.svg";
import iconLocation from "../assets/svgs/Icon_Ubicacion.svg";
import iconQuotation from "../assets/svgs/Icon_Quotation.svg";

declare const window: any;

export default function PortraitOptions({setShowPortraitOptions}: any) {

  const [isVisible, setIsVisible] = React.useState(true);

  const handleHidePortrait = () => {
    setIsVisible(false)
    setTimeout(() => {
      setShowPortraitOptions(false)
    }, 900);
  };

  const openInNewTab = (url: string) => {
    window.open(url, "_blank", "noreferrer");
  };

  return (
    <div className={`full-portrait-options ${isVisible ? 'transition-swipe-left' : 'transition-swipe-right'}`} onClick={() => handleHidePortrait()}>
      <div className="portrait-options-container" onClick={(e) => {e.stopPropagation()}}>

        <img className={`portrait-options-logo`} src={logo} alt=''/>
        <div className="portrait-options-buttons-container">

          <div className="portrait-options-button" onClick={() => window.location.reload()} >
            <div className="portrait-options-button-text">
              Inicio
            </div>
          </div>

          <div className="portrait-options-button" onClick={() => openInNewTab("https://www.acesco.com.co/contacto/")} >
            <img className={`portrait-options-button-icon`} src={iconQuotation} alt=''/>
            <div className="portrait-options-button-text">
              Cotiza
            </div>
          </div>

          <div className="portrait-options-button" onClick={() => openInNewTab("https://www.acesco.com.co/distribuidores/")} >
            <img className={`portrait-options-button-icon`} src={iconLocation} alt=''/>
            <div className="portrait-options-button-text">
              Distribuidores
            </div>
          </div>

          <div className="portrait-options-button" onClick={() => openInNewTab("https://www.acesco.com.co/garantia-de-productos/")} >
            <img className={`portrait-options-button-icon`} src={iconWarranty} alt=''/>
            <div className="portrait-options-button-text">
              Garantía
            </div>
          </div>

        </div>

        <div className={`portrait-options-button-close`} onClick={() => handleHidePortrait()} >
          <div className="portrait-options-button-close-text">
            Cerrar
          </div>
        </div>
      </div>
    </div>
  );
};
